export function mapSource(tenant: string): string {
    switch (tenant) {
        case "1012": {
            return "Foothill Ranch"
        }
        case "1060": {
            return "Blue Ribbon"
        }
        case "1065": {
            return "Cortez"
        }
        case "1064": {
            return "Wings"
        }
        case "1264": {
            return "The Court"
        }
        case "1063": {
            return "Samples"
        }
        case "1067": {
            return "Windrunner"
        }
        case "1081": {
            return "Flight"
        }
        case "1093": {
            return "Impact"
        }
        case "1098": {
            return "Tepana"
        }
        default: {
            return "Undefined"
        }
    }
}
